const imageLoadCache = new Map();

export const getQuestionGroupImageUrl = (questionGroup, imageBaseUrl) => {
  return questionGroup?.image ? `${imageBaseUrl}/${questionGroup.image}` : "";
};

export const getQuestionGroupImageUrls = (questionGroups, imageBaseUrl) => {
  return Array.from(
    new Set(questionGroups.map((group) => getQuestionGroupImageUrl(group, imageBaseUrl)).filter(Boolean))
  );
};

export const preloadImage = (url) => {
  if (!imageLoadCache.has(url)) {
    imageLoadCache.set(
      url,
      new Promise((resolve) => {
        const image = new Image();
        image.decoding = "async";
        image.onload = () => resolve({ url, status: "loaded" });
        image.onerror = () => resolve({ url, status: "failed" });
        image.src = url;
      })
    );
  }

  return imageLoadCache.get(url);
};

export const preloadImages = (urls, onSettled) => {
  return Promise.all(
    urls.map((url) =>
      preloadImage(url).then((result) => {
        if (onSettled) {
          onSettled(result);
        }

        return result;
      })
    )
  );
};

export const preloadTestQuestionResources = (questionGroups, imageBaseUrl, onSettled) => {
  return preloadImages(getQuestionGroupImageUrls(questionGroups, imageBaseUrl), onSettled);
};
